export default __webpack_public_path__ + "static/media/you_missed_a_step.b103df43.svg";